import React, { useContext, useEffect, useState } from 'react';
import { ApiContext } from '@api/api';
import { CompanyLocationsDetailOutDTO } from '@api/ringil-api.v2';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import COTimezone from '@components/FigmaComponents/COTimezone.tsx';
import SvgMapPin from '@icons/map-pin.svg?react';
import SvgBusiness from '@icons/business.svg?react';

interface ComponentProps {
  locationId?: string;
  // Figma uses two header variants: 'location' (MapPin + "Location") for opening hours / ramp,
  // 'locality' (Business + "Locality") for contact / visibility / CMR.
  variant?: 'location' | 'locality';
}

const LocationSidebarHeader: React.FC<ComponentProps> = ({ locationId, variant = 'location' }) => {
  const { tr } = useTranslationLgs();
  const { getCompanyLocationById } = useContext(ApiContext);
  const [location, setLocation] = useState<CompanyLocationsDetailOutDTO>();

  useEffect(() => {
    if (locationId) getCompanyLocationById(locationId, setLocation);
  }, [locationId]);

  if (!location) return null;

  const Icon = variant === 'locality' ? SvgBusiness : SvgMapPin;
  const label = variant === 'locality' ? tr('LocalityDetail.locality', 'Locality') : tr('LocalityDetail.location', 'Location');

  return (
    <div className={'flex flex-col gap-4'}>
      <div className={'flex items-start justify-between gap-4'}>
        <div className={'flex items-start gap-2'}>
          <Icon className={'mt-0.5 h-4 w-4 text-content-tertiary'} />
          <div className={'flex flex-col'}>
            <span className={'text-sm font-medium text-content-secondary'}>{label}</span>
            <span className={'text-base font-bold text-content-primary'}>{location.name}</span>
          </div>
        </div>
        {variant === 'location' && <COTimezone timezoneId={location.timezoneId} />}
      </div>
      <div className={'h-px w-full bg-content-quaternary'} />
    </div>
  );
};

export default LocationSidebarHeader;
